export default class MonthYearName {    
    public id: string = "";
    public label: string = "";
    public name: string = "";
}